import { CanMatchFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthorizationService } from '../services/authorization.service';
import { AuthSessionService } from '../services/auth-session.service';
import { RouteAuthPolicy } from '../models';
import { LocaleService } from '../../services/locale.service';

export const authorizationGuard: CanMatchFn = async (route) => {
  const authorizationService = inject(AuthorizationService);
  const authSessionService = inject(AuthSessionService);
  const router = inject(Router);
  const localeService = inject(LocaleService);

  const policy = route.data?.['auth'] as RouteAuthPolicy | undefined;

  if (!policy) {
    return true;
  }

  await authSessionService.initialize();

  if (authSessionService.hasExternalRedirectStarted()) {
    return false;
  }

  if (!authSessionService.isAuthEnabled()) {
    return true;
  }

  if (!authSessionService.isAuthenticated()) {
    return true;
  }

  if (authorizationService.hasAccess(policy)) {
    return true;
  }

  return router.parseUrl(localeService.stripSupportedLocalePrefix(localeService.withLocalePath('/unauthorized')));
};